
  export default {
    name: 'LinkCard',
    props: {
      link: {
        type: String,
        required: true,
        default: '/',
      },
    },
  }
